
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.682","height":"19.677","viewBox":"0 0 18.682 19.677"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.287 17.167l-6.958-7.329 6.958-7.328a1.586 1.586 0 000-2.094 1.4 1.4 0 00-1.988 0L9.341 7.744 2.383.418a1.4 1.4 0 00-1.988 0 1.586 1.586 0 000 2.094l6.958 7.326-6.958 7.329a1.586 1.586 0 000 2.094 1.4 1.4 0 001.988 0l6.958-7.329 6.958 7.329a1.4 1.4 0 001.988 0 1.586 1.586 0 000-2.094z","fill":"#fff"}})])
          )
        }
      }
    